import { z } from 'zod';
// Annotated point or range on a project's timeline.
export const createMarkerSchema = z.object({
    timeMs: z.number().int().min(0),
    label: z.string().max(200).default(''),
    color: z.string().max(20).default('#f59e0b'),
    endMs: z.number().int().min(0).nullable().optional(),
});
export const updateMarkerSchema = z.object({
    timeMs: z.number().int().min(0).optional(),
    label: z.string().max(200).optional(),
    color: z.string().max(20).optional(),
    endMs: z.number().int().min(0).nullable().optional(),
});
//# sourceMappingURL=marker.schemas.js.map